import React from "react";
import {
  TextInput,
  BooleanInput,
  required,
  FormTab,
  SelectInput,
} from "react-admin";
import { dashboards } from "../../dashboard";

export const GeneralInformationTab = (props: any) => {
  return (
    <FormTab {...props} label="resources.admin-roles.labels.generalInformation">
      <TextInput
        source="name"
        label="resources.admin-roles.labels.name"
        validate={required()}
        disabled={props.record?.isStatic}
      />
      <BooleanInput
        source="isDefault"
        label="resources.admin-roles.labels.isDefault"
        disabled={props.record?.isStatic}
      />
      <SelectInput source="defaultDashboard" choices={dashboards} />
    </FormTab>
  );
};
